import React from "react";
import type { InputProps } from "@mui/joy";
import DarkInput from "./DarkInput";

export type NumericMode = "int" | "decimal";

export type NumericInputProps = Omit<InputProps, "type" | "onChange" | "value"> & {
  mode: NumericMode;
  value: string;
  onValueChange: (value: string) => void;
  allowNegative?: boolean;
};

function isValidNumericLike(mode: NumericMode, allowNegative: boolean, s: string): boolean {
  if (s === "") return true;
  if (mode === "int") {
    return allowNegative ? /^-?\d*$/.test(s) : /^\d*$/.test(s);
  }
  // decimal
  return allowNegative ? /^-?\d*(?:[.,]\d*)?$/.test(s) : /^\d*(?:[.,]\d*)?$/.test(s);
}

const NumericInput = React.forwardRef<HTMLInputElement, NumericInputProps>(function NumericInput(
  { mode, value, onValueChange, allowNegative = false, slotProps, ...props },
  ref,
) {
  const inputMode = mode === "int" ? "numeric" : "decimal";

  return (
    <DarkInput
      {...props}
      ref={ref}
      type="text"
      value={value}
      slotProps={{
        ...slotProps,
        input: {
          inputMode,
          ...(slotProps as any)?.input,
        },
      }}
      onChange={(e) => {
        const next = e.target.value;
        if (!isValidNumericLike(mode, allowNegative, next)) return;
        onValueChange(next);
      }}
    />
  );
});

export default NumericInput;
